import guest from "@/middlewares/guest";
import auth from "@/middlewares/auth";
import {cloudServerRoutes} from "@/routes/services/cloudServerRoutes";
import {cloudDiskRoutes} from "@/routes/services/cloudDiskRoutes";
import {cloudNetworkRoutes} from "@/routes/services/cloudNetworkRoutes";
import {portForwardingRoutes} from "@/routes/services/portForwardingRoutes";
import {firewallRoutes} from "@/routes/services/firewallRoutes";
import {billingRoutes} from "@/routes/billings/billingRoutes";
import {cloudIamRoutes} from "@/routes/iam/cloudIamRoutes";
import {cloudAccountRoutes} from "@/routes/account/cloudAccountRoutes";
import {sshKeypairRoutes} from "@/routes/services/sshKeypairRoutes";
import {supportRoutes} from "@/routes/support/supportRoutes";


let routes = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Login'),
    name: 'login',
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/register',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Register'),
    name: 'register',
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/email-verification/:token',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/EmailVerification'),
    name: 'email-verification',
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/forgot-password',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/ForgotPassword'),
    name: 'forgot-password',
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/reset-password/:token',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/ResetPassword'),
    name: 'reset-password',
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard'),
    name: 'dashboard',
    meta: {
      middleware: [
        auth
      ]
    }
  }
]

routes.push(...cloudServerRoutes);
routes.push(...cloudDiskRoutes);
routes.push(...cloudNetworkRoutes);
routes.push(...portForwardingRoutes);
routes.push(...firewallRoutes);
routes.push(...billingRoutes);
routes.push(...cloudIamRoutes);
routes.push(...cloudAccountRoutes);
routes.push(...sshKeypairRoutes);
routes.push(...supportRoutes);
export default routes;
